import React, { useState, useEffect } from "react";
import { Container, HeaderContainer } from "./styles";
import { Table, Button, Tag, Modal, Form, Input, Select, DatePicker } from "antd";
import { SendOutlined, ClockCircleOutlined, CheckCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

const { Option } = Select;
const { TextArea } = Input;

const generateMockNotifications = (count) => {
  const statuses = ["Sent", "Scheduled"];
  const audiences = ["Todos", "Free", "Premium", "Inativos"];
  const data = [];
  
  for (let i = 1; i <= count; i++) {
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    data.push({
      key: i,
      id: i,
      title: `Novidade Imperdível ${i}`,
      message: "Confira as novas receitas adicionadas ao app!",
      audience: audiences[Math.floor(Math.random() * audiences.length)],
      date: new Date(2025, 0, Math.floor(Math.random() * 30) + 1).toLocaleDateString('pt-BR') + ' 14:30',
      status: status,
    });
  }
  return data;
};

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setItems(generateMockNotifications(20));
      setLoading(false);
    }, 500);
  }, []);

  const handleSend = (values) => {
    console.log("Sending Notification:", values);
    toast.success("Notificação disparada com sucesso!");
    
    // Add to list (mock)
    const newItem = {
        key: Date.now(),
        id: Date.now(),
        title: values.title,
        message: values.message,
        audience: values.audience,
        date: new Date().toLocaleDateString('pt-BR') + ' ' + new Date().toLocaleTimeString('pt-BR'),
        status: values.schedule ? 'Scheduled' : 'Sent'
    };
    
    setItems([newItem, ...items]);
    setIsModalOpen(false);
    form.resetFields();
  };

  const columns = [
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Mensagem",
      dataIndex: "message",
      key: "message",
      ellipsis: true,
    },
    {
      title: "Público",
      dataIndex: "audience",
      key: "audience",
      render: (aud) => <Tag color="blue">{aud}</Tag>,
    },
    {
      title: "Data Disparo",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag icon={status === 'Sent' ? <CheckCircleOutlined /> : <ClockCircleOutlined />} color={status === 'Sent' ? 'success' : 'warning'}>
            {status === 'Sent' ? 'Enviado' : 'Agendado'}
        </Tag>
      ),
    },
  ];

  return (
    <Container>
      <HeaderContainer>
        <h1>Disparo de Notificações</h1>
        <div className="actions-container">
            <Button type="primary" icon={<SendOutlined />} onClick={() => setIsModalOpen(true)} size="large">
                Nova Notificação
            </Button>
        </div>
      </HeaderContainer>

      <Table 
        columns={columns} 
        dataSource={items} 
        loading={loading}
        pagination={{ position: ['bottomCenter'], pageSize: 10 }}
        rowKey="id"
      />

      <Modal
        title="Enviar Nova Notificação"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
        okText="Enviar / Agendar"
        cancelText="Cancelar"
      >
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSend}
            initialValues={{ audience: 'Todos' }}
        >
            <Form.Item
                name="title"
                label="Título da Notificação"
                rules={[{ required: true, message: 'Insira o título' }]}
            >
                <Input placeholder="Ex: Novas Receitas Disponíveis!" />
            </Form.Item>

            <Form.Item
                name="message"
                label="Mensagem (Body)"
                rules={[{ required: true, message: 'Insira a mensagem' }]}
            >
                <TextArea rows={3} placeholder="Texto curto que aparecerá na notificação..." />
            </Form.Item>

            <Form.Item
                name="audience"
                label="Público Alvo"
                rules={[{ required: true }]}
            >
                <Select>
                    <Option value="Todos">Todos os Usuários</Option>
                    <Option value="Free">Usuários Free</Option>
                    <Option value="Premium">Usuários Premium</Option>
                    <Option value="Inativos">Usuários Inativos (30 dias)</Option>
                </Select>
            </Form.Item>

            <Form.Item
                name="schedule"
                label="Agendar para (Opcional)"
                help="Deixe em branco para enviar imediatamente"
            >
                <DatePicker showTime format="DD/MM/YYYY HH:mm" style={{ width: '100%' }} />
            </Form.Item>
        </Form>
      </Modal>
    </Container>
  );
}
